import { render } from "./RouteDetails.vue?vue&type=template&id=5a64f982&scoped=true"
import script from "./RouteDetails.vue?vue&type=script&lang=js"
export * from "./RouteDetails.vue?vue&type=script&lang=js"

import "./RouteDetails.vue?vue&type=style&index=0&id=5a64f982&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a64f982"]])

export default __exports__